module.exports = __webpack_public_path__ + "00038cfc08715b57cc4d0848b75cc316.svg";